import {cs}          from "./chain-services";
import {Static}      from "./static";
import {TimedAction} from "./timed-action";

export const TimeoutAction = ({delay=500, action}) => cs(
    ["s", (_, next) => Static({
        getInitValue: () => Date.now(),
        next,
    })],
    ({s}) => TimedAction({
        time: s + delay,
        action,
    }),
);
